import {
  ADD_USER_FAIL,
  ADD_USER_REQUEST,
  ADD_USER_SUCCESS,
  CHANGE_USER_STATUS_FAIL,
  CHANGE_USER_STATUS_REQUEST,
  CHANGE_USER_STATUS_SUCCESS,
  DELETE_USER_FAIL,
  DELETE_USER_REQUEST,
  DELETE_USER_SUCCESS,
  EDIT_USER_FAIL,
  EDIT_USER_REQUEST,
  EDIT_USER_SUCCESS,
  GET_USER_DATA_FAIL,
  GET_USER_DATA_REQUEST,
  GET_USER_DATA_SUCCESS,
  GET_USER_LIST_DATA_FAIL,
  GET_USER_LIST_DATA_REQUEST,
  GET_USER_LIST_DATA_SUCCESS,
} from "../constant";

const initialState = {
  userData: [],
  totalRecords: null,
  userDataLoading: false,
  isAddingUser: false,
  isDeleteUser: false,
  loggedInUserDetail: null,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_LIST_DATA_REQUEST:
      return {
        ...state,
        totalRecords: null,
        userDataLoading: true,
      };
    case GET_USER_LIST_DATA_SUCCESS:
      console.log("here", action.payload);
      return {
        ...state,
        userData: action.payload,
        totalRecords: action.payload?.totalRecords,
        userDataLoading: false,
      };
    case GET_USER_LIST_DATA_FAIL:
      return {
        ...state,
        userData: [],
        totalRecords: null,
        userDataLoading: false,
      };

    //Add user
    case ADD_USER_REQUEST:
      return {
        ...state,
        isAddingUser: true,
      };
    case ADD_USER_SUCCESS:
      return {
        ...state,
        isAddingUser: false,
      };
    case ADD_USER_FAIL:
      return {
        ...state,
        isAddingUser: false,
      };
    case EDIT_USER_REQUEST:
      return {
        ...state,
        isAddingUser: true,
      };
    case EDIT_USER_SUCCESS:
      return {
        ...state,
        isAddingUser: false,
      };
    case EDIT_USER_FAIL:
      return {
        ...state,
        isAddingUser: false,
      };

    case DELETE_USER_REQUEST:
      return {
        ...state,
        isDeleteUser: true,
      };
    case DELETE_USER_SUCCESS:
      return {
        ...state,
        isDeleteUser: false,
      };
    case DELETE_USER_FAIL:
      return {
        ...state,
        isDeleteUser: false,
      };

    case CHANGE_USER_STATUS_REQUEST:
      return {
        ...state,
      };
    case CHANGE_USER_STATUS_SUCCESS:
      return {
        ...state,
      };
    case CHANGE_USER_STATUS_FAIL:
      return {
        ...state,
      };

    case GET_USER_DATA_REQUEST:
      return {
        ...state,
        userDataLoading: true,
      };
    case GET_USER_DATA_SUCCESS:
      return {
        ...state,
        userDataLoading: false,
        loggedInUserDetail: action.payload,
      };
    case GET_USER_DATA_FAIL:
      return {
        ...state,
        userDataLoading: false,
        loggedInUserDetail: null,
      };

    default:
      return state;
  }
};

export { userReducer };
